import { ClinicalTrialFormsAssignedView } from 'src/pages/ClinicalTrial/ClinicalTrialForms/ClinicalTrialFormsAssigned/ClinicalTrialFormsAssigned.view';
import { useClinicalTrialSlice } from '@restore/clinicalTrial/clinicalTrial.slice';
import { selectClinicalTrialWithFullQuestionnaireInfo } from '@restore/questionnaires/questionnaries.selector';
import { useEffect, useMemo } from 'react';
import { Button } from 'antd';
import { twMerge } from '@utils/twMerge';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { VisitConfigQuestionnaires } from '@dynamika-shared/types/visits';
import { useAppSelector } from '@hooks/redux';
import { useQuestionnairesSlice } from '@restore/questionnaires/questionnaires.slice';
import './style.scss';
import { useClinicalTrialFormSlice } from '@restore/clinicalTrialForms/clinicalTrialForms.slice';
import { useParams } from '@hooks/useParams';

export const ClinicalTrialFormsAssigned = () => {
  const id = useParams().id as string;
  const [selectedCohort, setSelectedCohort] = useClinicalTrialFormSlice(
    (state, actions) => [
      state.selectedCohort?.[id] || null,
      actions.setSelectedCohort,
    ]
  );
  const clinicalTrial = useAppSelector(
    selectClinicalTrialWithFullQuestionnaireInfo
  );

  const [loading, cohorts] = useClinicalTrialSlice(state => [
    state.clinicalTrialActionLoading,
    state.data?.cohorts || [],
  ]);
  const { loadingQuestionnaires } = useQuestionnairesSlice();

  const visits = useMemo(
    () =>
      (clinicalTrial.cohorts.find(c => c.id === selectedCohort?.id)
        ?.visits as VisitConfigQuestionnaires[]) || [],
    [clinicalTrial, selectedCohort]
  );

  const visitDefault = useMemo(
    () =>
      [
        {
          id: 'default',
          name: 'Default',
          daysFromBaseline: 0,
          labels: [],
          questionnaires: clinicalTrial.questionnaires,
        },
      ] as unknown as VisitConfigQuestionnaires[],
    [clinicalTrial.questionnaires]
  );

  useEffect(() => {
    !selectedCohort && setSelectedCohort({ key: id, cohort: cohorts[0] });
  }, []);

  return (
    <div className={'h-full'}>
      <ClinicalTrialFormsAssignedView
        loading={loading}
        data={visitDefault}
        clinicalTrial={clinicalTrial}
      />
      <div className={'flex h-full'}>
        <div
          className={
            'flex-col gap-1 py-2 bg-blueTone h-full rounded-[1.2rem] me-4'
          }
        >
          {clinicalTrial.cohorts.map(cohort => (
            <Button
              key={cohort.id}
              type={'text'}
              className={twMerge(
                'text-1624 font-semibold sub-navigation-btn h-[4rem] !inline-block text-dimGray w-[27rem]',
                selectedCohort?.id === cohort.id && '!text-[#1D8EF2]'
              )}
              onClick={() => setSelectedCohort({ key: id, cohort })}
            >
              <div className={'flex items-center justify-between pe-3'}>
                <div className={'whitespace-nowrap'}>{cohort.name}</div>
                {selectedCohort?.id === cohort.id ? (
                  <ChevronIcon dir='right' className={'text-dodgerBlue'} />
                ) : (
                  <div className={'w-2'}></div>
                )}
              </div>
            </Button>
          ))}
        </div>

        {!loadingQuestionnaires && !loading && (
          <ClinicalTrialFormsAssignedView
            loading={loading && loadingQuestionnaires}
            data={visits}
            clinicalTrial={clinicalTrial}
          />
        )}
      </div>
    </div>
  );
};
